





















import { defineComponent, ref } from '@vue/composition-api';

const ResultCard = defineComponent({
  setup() {
    const showModal = ref(false);

    return {
      showModal,
    };
  },
  props: {
    card: { required: true },
    shouldShowArrow: { default: true },
  },
});

export default ResultCard;
